/* eslint-disable ts/no-unused-expressions */
import { Component, Container, DefaultSelectListItemRenderer, Input, InteractiveContainer, SelectableContainer, SelectList, SelectListItemRenderer, SVG, SVGPath, Text } from '@acies/core';
import { Badge, Button, Divider, FileDropPicker, FormInput, HTMLSelectList, HTMLSelectListItemRenderer, Icon, InputField, InputPopupSelector, KeyboardShortcut, Label, SpinnerOverlay, StrokeContainer } from '@acies/ui';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withXhr } from '@angular/common/http';
import localeDa from '@angular/common/locales/da';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CUSTOM_DATE_FORMATS, CustomDateAdapter } from '@shared/adapters/custom-date-adapter';
import { ActionMenuElement } from '@shared/components/action-element/actionmenuelement.component';
import { ConfirmdialogComponent } from '@shared/components/confirmdialog/confirmdialog.component';
import { FileuploadComponent } from '@shared/components/fileupload/fileupload.component';
import { GenerictableComponent } from '@shared/components/generictable/generictable.component';
import { HeaderSubMenuComponent } from '@shared/components/header-sub-menu/header-sub-menu.component';
import { ImportErrorPopupComponent } from '@shared/components/import-error-popup/import-error-popup.component';
import { SidebarwidgetComponent } from '@shared/components/sidebarwidget/sidebarwidget.component';
import { SimpleeditdialogComponent } from '@shared/components/simpleeditdialog/simpleeditdialog.component';
import { SmallscreensComponent } from '@shared/components/smallscreens/smallscreens.component';
import { TimezonePickerComponent } from '@shared/components/timezone-picker/timezone-picker.component';
import { TransferErrorPopupComponent } from '@shared/components/transfer-error-popup/transfer-error-popup.component';
import { AutoFocusDirective } from '@shared/directives/auto-focus-directive';
import { DisableWithoutPermissionDirective } from '@shared/directives/disable-without-permission-directive';
import { HasPermissionDirective } from '@shared/directives/has-permission-directive';
import { OnlyDecimalDirective } from '@shared/directives/only-decimal-directive';
import { OnlyNumbersDirective } from '@shared/directives/only-numbers-directive';
import { OnlyPositiveIntegersDirective } from '@shared/directives/only-positive-integers-directive';
import { OnlyRegexPatternDirective } from '@shared/directives/only-reqex-pattern-directive';
import { OnlyZeroAndOneDirective } from '@shared/directives/only-zero-and-one-directive';
import { PreventDoubleClickDirective } from '@shared/directives/prevent-double-click';
import { AccountFilterPipe } from '@shared/filters/accountfilter.pipe';
import { ReportFilterPipe } from '@shared/filters/reportfilter.pipe';
import { ArraySortPipe } from '@shared/filters/sortby.pipe';
import { AciesDateFormatPipe } from '@shared/pipes/acies-date-format.pipe';
import { ConditionalFormatPipe } from '@shared/pipes/conditional-format.pipe';
import { DynamicPipeComponent } from '@shared/pipes/dynamic-component.pipe';
import { SyncStatusTranslatePipe } from '@shared/pipes/sync-status-translate.pipe';
import { UserToNamePipe } from '@shared/pipes/user-to-name.pipe';
import { QRCodeComponent } from 'angularx-qrcode';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { CountdownModule } from 'ngx-countdown';
import { FileSaverModule } from 'ngx-filesaver';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { environment } from '../environments/environment';
import { AdminComponent } from './admin/admin.component';
import { DrawingsComponent } from './admin/drawings/drawings.component';
import { FeatureFlagsComponent } from './admin/featureflags/featureflags.component';
import { IpsettingsComponent } from './admin/ipsettings/ipsettings.component';
import { CreatePolicyDialogComponent } from './admin/scim-administration/create-policy-dialog/create-policy-dialog.component';
import { CreatePolicyMapDialogComponent } from './admin/scim-administration/create-policy-map-dialog/create-policy-map-dialog.component';
import { PolicyDetailDialogComponent } from './admin/scim-administration/policy-detail-dialog/policy-detail-dialog.component';
import { PolicyMapDetailDialogComponent } from './admin/scim-administration/policy-map-detail-dialog/policy-map-detail-dialog.component';
import { ScimAdministrationComponent } from './admin/scim-administration/scim-administration.component';
import { ScimGroupDetailDialogComponent } from './admin/scim-administration/scim-group-detail-dialog/scim-group-detail-dialog.component';
import { ScimTokenDialogComponent } from './admin/scim-administration/scim-token-dialog/scim-token-dialog.component';
import { ScimUserDetailDialogComponent } from './admin/scim-administration/scim-user-detail-dialog/scim-user-detail-dialog.component';
import { UpdatePolicyDialogComponent } from './admin/scim-administration/update-policy-dialog/update-policy-dialog.component';
import { CreateWorkerDialogComponent } from './admin/sync-monitoring/create-worker-dialog/create-worker-dialog.component';
import { RepairEnvironmentDialogComponent } from './admin/sync-monitoring/repair-environment-dialog/repair-environment-dialog.component';
import { ResetSyncDialogComponent } from './admin/sync-monitoring/reset-sync-dialog/reset-sync-dialog.component';
import { AuditReportDialogComponent } from './admin/sync-monitoring/audit-report-dialog/audit-report-dialog.component';
import { SourceDriftDialogComponent } from './admin/sync-monitoring/source-drift-dialog/source-drift-dialog.component';
import { AuditTabComponent } from './admin/sync-monitoring/audit-tab/audit-tab.component';
import { DriftAuditDialogComponent } from './admin/sync-monitoring/drift-audit-dialog/drift-audit-dialog.component';
import { KeepMarksDialogComponent } from './admin/sync-monitoring/keep-marks-dialog/keep-marks-dialog.component';
import { ReplaySkippedDialogComponent } from './admin/sync-monitoring/replay-skipped-dialog/replay-skipped-dialog.component';
import { SyncMonitoringComponent } from './admin/sync-monitoring/sync-monitoring.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdSignInComponent } from './auth/ad-sign-in/ad-sign-in.component';
import { AdSignOutComponent } from './auth/ad-sign-out/ad-sign-out.component';
import { DialogConfirmForgotPasswordComponent, SignInComponent } from './auth/sign-in/sign-in.component';
import { Breadcrumb2Module } from './breadcrumb2/breadcrumb2.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CalculationsComponent } from './calculations/calculations.component';
import { MatricesComponent } from './calculations/matrices/matrices.component';
import { CoreComponent } from './core/core.component';
import { DocsComponent } from './docs/docs.component';
import { MappingsComponent } from './docs/mappings/mappings.component';
import { TemplateDeleteConfirmDialogContentComponent } from './docs/templates/confirm-dialog-content/confirmDialogContent.component';
import { TemplatesComponent } from './docs/templates/templates.component';
import { UpdateBatchMutation } from './graphql/mutations/update-batch';
import { GetItemOperationsByTerminalAndBatchQuery } from './graphql/queries/get-itemoperation';
import { CompleteItemOperationSubscription } from './graphql/subscriptions/on-complete-item-operation';
import { CreateActiveElementSubscription } from './graphql/subscriptions/on-create-active-element';
import { CreateBatchSubscription } from './graphql/subscriptions/on-create-batch';
import { CreateProductionNoteSubscription } from './graphql/subscriptions/on-create-production-note';
import { DeleteBatchSubscription } from './graphql/subscriptions/on-delete-batch';
import { DeleteProductionNoteSubscription } from './graphql/subscriptions/on-delete-production-note';
import { ReorderItemOperationSubscription } from './graphql/subscriptions/on-reorder-item-operation';
import { UpdateBatchSubscription } from './graphql/subscriptions/on-update-batch';
import { UpdateProductionNoteSubscription } from './graphql/subscriptions/on-update-production-note';
import { UpdateTerminalStatusSubscription } from './graphql/subscriptions/on-update-terminalstatus';
import { GraphQLProvider } from './graphql/utils/graphql.provider';
import { AccountComponent } from './insights/administration/account/account.component';
import { DialogAccountGroupsComponent } from './insights/administration/account/groups/dialog-account-groups/dialog-account-groups.component';
import { AdministrationComponent } from './insights/administration/administration.component';
import { BudgetsComponent } from './insights/administration/budgets/budgets.component';
import { DialogDragdropFileComponent } from './insights/administration/budgets/dialog-dragdrop-file/dialog-dragdrop-file.component';
import { DndDirective } from './insights/administration/budgets/dialog-dragdrop-file/dnd.directive';
import { DialogExturlComponent } from './insights/administration/reports/exturl/dialog-exturl/dialog-exturl.component';
import { AdminReportsComponent, DialogDataDeleteDialogComponent, DialogReportCategoriesComponent } from './insights/administration/reports/reports.component';
import { DialogUserReportsComponent } from './insights/administration/users/reports/dialog-user-reports/dialog-user-reports.component';
import { DialogUserAccessDialogComponent, UsersComponent } from './insights/administration/users/users.component';
import { InsightsComponent } from './insights/insights.component';
import { ReportsComponent } from './insights/reports/reports.component';
import { SlideshowComponent } from './insights/slideshow/slideshow.component';
import { InviteComponent } from './invite/invite.component';
import { LogoutComponent } from './logout/logout.component';
import { CartingConfigComponent } from './masterdata/carting/configuration/carting.config.component';
import { CartingCreateUpdateWagonDialogComponent } from './masterdata/carting/wagons/carting-create-update/carting-create-update-wagon';
import { CartingWagonsComponent } from './masterdata/carting/wagons/carting.wagons.component';
import { CO2Component } from './masterdata/co2/co2.component';
import { ComponentCO2List } from './masterdata/co2/view/component-co2-list';
import { ComponentCO2LinkList } from './masterdata/co2/view/component-co2link-list';
import { ImportComponentCO2LinkList } from './masterdata/co2/view/import-component-co2link-list';
import { BasketsComponent } from './masterdata/cutting/baskets/baskets.component';
import { CreateUpdateBasketDialogComponent } from './masterdata/cutting/baskets/create-update-basket/create-update-basket';
import { ConfigsComponent } from './masterdata/cutting/configs/configs.component';
import { CreateUpdateColorDialogComponent } from './masterdata/cutting/configs/create-update-color/create-update-color';
import { CreateUpdateMachineDialogComponent } from './masterdata/cutting/configs/create-update-machine/create-update-machine';
import { CreateUpdateRuleDialogComponent } from './masterdata/cutting/rules/create-update-rule/create-update-rule';
import { RulesComponent } from './masterdata/cutting/rules/rules.component';
import { CreateUpdateSetupDialogComponent } from './masterdata/cutting/setups/create-update-setup/create-update-setup';
import { SetupsComponent } from './masterdata/cutting/setups/setups.component';
import { MasterdataComponent } from './masterdata/masterdata.component';
import { CreateUpdateLayerParamDialogComponent } from './masterdata/palletising/configuration/create-update-layer-param/create-update-layer-param';
import { CreateUpdateStackParamDialogComponent } from './masterdata/palletising/configuration/create-update-stack-param/create-update-stack-param';
import { PalletisingConfigurationComponent } from './masterdata/palletising/configuration/palletising.configuration.component';
import { CreateUpdateGroupingDialogComponent } from './masterdata/palletising/groupings/create-update-grouping/create-update-grouping';
import { GroupingsComponent } from './masterdata/palletising/groupings/groupings.component';
import { CreateUpdatePalletsDialogComponent } from './masterdata/palletising/pallets/create-update-pallets/create-update-pallets';
import { PalletsComponent } from './masterdata/palletising/pallets/pallets.component';
import { CreateUpdateZipCodeDialogComponent } from './masterdata/palletising/zipcode/create-update-zipcode/create-update-zipcode';
import { ZipCodeComponent } from './masterdata/palletising/zipcode/zipcode.component';
import { RackingCreateUpdateRackDialogComponent } from './masterdata/racking/racks/racking-create-update/racking-create-update-rack';
import { RackingRacksComponent } from './masterdata/racking/racks/racking.racks.component';
import { RackingCreateUpdateRacksetDialogComponent } from './masterdata/racking/racksets/racking-create-update/racking-create-update-rackset';
import { RackingRacksetsComponent } from './masterdata/racking/racksets/racking.racksets.component';
import { RackingCreateUpdateRuleDialogComponent } from './masterdata/racking/rules/racking-create-update-rule/racking-create-update-rule';
import { RackingRulesComponent } from './masterdata/racking/rules/racking.rules.component';
import { RegistersComponent } from './masterdata/registers/registers.component';
import { SingleregisterComponent } from './masterdata/singleregister/singleregister.component';
import { MaterialModule } from './material.module';
import { ListItemComponent } from './menu-list-item/list-item/list-item.component';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { MesCjsTerminalRegisterComponent } from './mes-cjs/mes-cjs-terminal/mes-cjs-terminal-register/mes-cjs-terminal-register.component';
import { MesCjsTerminalComponent } from './mes-cjs/mes-cjs-terminal/mes-cjs-terminal.component';
import { MesCjsComponent } from './mes-cjs/mes-cjs.component';
import { CalendarComponent } from './mes/calendar/calendar.component';
import { CreateAppointmentComponent } from './mes/calendar/create-appointment/create-appointment.component';
import { CreateCalendarComponent } from './mes/calendar/create-calendar/create-calendar.component';
import { CreateHolidaysComponent } from './mes/calendar/create-holidays/create-holidays.component';
import { DeleteCalendarComponent } from './mes/calendar/delete-calendar/delete-calendar.component';
import { UpdateAppointmentComponent } from './mes/calendar/update-appointment/update-appointment.component';
import { CreateIncidentCodeComponent } from './mes/incident-code/create-incident-code/create-incident-code.component';
import { DeleteIncidentCodeComponent } from './mes/incident-code/delete-incident-code/delete-incident-code.component';
import { IncidentCodeComponent } from './mes/incident-code/incident-code.component';
import { UpdateIncidentCodeComponent } from './mes/incident-code/update-incident-code/update-incident-code.component';
import { BatchStatusComponent } from './mes/mes-batch/batch-status.component';
import { CreateBatchComponent } from './mes/mes-batch/create-batch/create-batch.component';
import { DeleteBatchComponent } from './mes/mes-batch/delete-batch/delete-batch.component';
import { EditBatchComponent } from './mes/mes-batch/edit-batch/edit-batch.component';
import { MesBatchComponent } from './mes/mes-batch/mes-batch.component';
import { EmployeeCheckinComponent } from './mes/mes-components/employee-checkin/employee-checkin.component';
import { IncidentCodeSelectComponent } from './mes/mes-components/incident-code-select/incident-code-select.component';
import { ItemSelectControlComponent } from './mes/mes-components/item-select-control/item-select-control.component';
import { ListPrintConfigurationComponent } from './mes/mes-components/list-print-configuration/list-print-configuration.component';
import { MesQrComponentComponent } from './mes/mes-components/mes-qr-component/mes-qr-component.component';
import { ProductionDataViewDetailComponent } from './mes/mes-components/production-data-view/production-data-view-detail/production-data-view-detail.component';
import { ProductionDataViewComponent } from './mes/mes-components/production-data-view/production-data-view.component';
import { ReorderProductionNoteListComponent } from './mes/mes-components/reorder-production-note-list/reorder-production-note-list.component';
import { SlidePanelComponent } from './mes/mes-components/slide-panel/slide-panel.component';
import { TaskSelectComponent } from './mes/mes-components/task-select/task-select.component';
import { TerminalMenuComponent } from './mes/mes-components/terminal-menu/terminal-menu.component';
import { TerminalSelectComponent } from './mes/mes-components/terminal-select.ts/terminal-select.component';
import { TerminalStationSelectComponent } from './mes/mes-components/terminal-station-select/terminal-station-select.component';
import { CreateUpdateDepartmentDialogComponent } from './mes/mes-department/create-update-department/create-update-department';
import { DepartmentComponent } from './mes/mes-department/department.component';
import { EditEmployeeNotesComponent } from './mes/mes-employee-note/edit/edit-employee-notes.component';
import { EmployeeNoteComponent } from './mes/mes-employee-note/employee-note.component';
import { CreateUpdateEmployeeDialogComponent } from './mes/mes-employee/create-update-employee/create-update-employee';
import { EmployeeComponent } from './mes/mes-employee/employee.component';
import { MesProductionTerminalTabDialogueComponent } from './mes/mes-production-terminal/mes-production-terminal-tab-dialog/mes-production-terminal-tab-dialog.component';
import { TerminalCreateProductionNoteComponent } from './mes/mes-production-terminal/mes-production-terminal-tab-dialog/terminal-create-production-note-dialog/terminal-create-production-note-dialog.component';
import { TerminalCreateStockReorderDialogComponent } from './mes/mes-production-terminal/mes-production-terminal-tab-dialog/terminal-create-stock-reorder-dialog/terminal-create-stock-reorder-dialog.component';
import { MesProductionTerminalComponent } from './mes/mes-production-terminal/mes-production-terminal.component';
import { TerminalCreateReorderDialogComponent } from './mes/mes-production-terminal/terminal-create-reorder-dialog/terminal-create-reorder-dialog.component';
import { MesComponent } from './mes/mes.component';
import { ProductionNoteComponent } from './mes/production-note/production-note.component';
import { CreateScanningPrefixComponent } from './mes/scanning-prefix/create-scanning-prefix/create-scanning-prefix.component';
import { DeleteScanningPrefixComponent } from './mes/scanning-prefix/delete-scanning-prefix/delete-scanning-prefix.component';
import { ScanningPrefixComponent } from './mes/scanning-prefix/scanning-prefix.component';
import { UpdateScanningPrefixComponent } from './mes/scanning-prefix/update-scanning-prefix/update-scanning-prefix.component';
import { CreateShiftNoteComponent } from './mes/shift/create-shift-note/create-shift-note.component';
import { MergeShiftsComponent } from './mes/shift/merge-shifts/merge-shifts.component';
import { ShiftApprovalComponent } from './mes/shift/mes-shift-approval.component';
import { ShiftStatusComponent } from './mes/shift/mes-shift-status.component.';
import { ShiftChecktimeListComponent } from './mes/shift/shift-checktime-list.component';
import { WorktaskSelectComponent } from './mes/shift/worktask-select/worktask-select.component';
import { DeleteStockReorderComponent } from './mes/stock-reorder/delete-stock-reorder/delete-stock-reorder.component';
import { StockReorderComponent } from './mes/stock-reorder/stock-reorder.component';
import { UpdateStockReorderComponent } from './mes/stock-reorder/update-stock-reorder/update-stock-reorder.component';
import { CreateUpdateTeamProfileDialogComponent } from './mes/team-profiles/create-update-team-profile/create-update-team-profile';
import { TeamProfilesComponent } from './mes/team-profiles/team-profiles.component';
import { CreateTerminalComponent } from './mes/terminal-administration/create-terminal/create-terminal.component';
import { DeleteTerminalComponent } from './mes/terminal-administration/delete-terminal/delete-terminal.component';
import { EditTerminalComponent } from './mes/terminal-administration/edit-terminal/edit-terminal.component';
import { TerminalAdministrationComponent } from './mes/terminal-administration/terminal-administration.component';
import { CreateTerminalTemplateComponent } from './mes/terminaltemplate-administration/create-terminaltemplate/create-terminaltemplate.component';
import { DeleteTerminalTemplateComponent } from './mes/terminaltemplate-administration/delete-terminaltemplate/delete-terminaltemplate.component';
import { EditTerminalTemplateComponent } from './mes/terminaltemplate-administration/edit-terminaltemplate/edit-terminaltemplate.component';
import { TerminalTemplateAdministrationComponent } from './mes/terminaltemplate-administration/terminaltemplate-administration.component';
import { WorktaskDialogComponent } from './mes/worktask/worktask-dialog';
import { WorktasksListComponent } from './mes/worktask/worktasks-list.component';
import { FloatingitemComponent } from './notificationcenter/floatingitems/floatingitem/floatingitem.component';
import { FloatingitemsComponent } from './notificationcenter/floatingitems/floatingitems.component';
import { InneritemComponent } from './notificationcenter/inneritem/inneritem.component';
import { NotificationcenterComponent } from './notificationcenter/notificationcenter.component';
import { NotificationitemComponent } from './notificationcenter/notificationitem/notificationitem.component';
import { MatPaginatorIntlCustom } from './paginator/custom-paginator-intl';
import { PrintCollectionJobsComponent } from './print/collection-jobs/print-collection-jobs.component';
import { PrintJobsComponent } from './print/jobs/print-jobs.component';
import { PrintTestComponent } from './print/print-test/print-test.component';
import { PrintComponent } from './print/print.component';
import { CreatePrinterComponent } from './print/printer-administration/create-printer/create-printer.component';
import { DeletePrinterComponent } from './print/printer-administration/delete-printer/delete-printer.component';
import { EditPrinterComponent } from './print/printer-administration/edit-printer/edit-printer.component';
import { PrinterAdministrationComponent } from './print/printer-administration/printer-administration.component';
import { CreateConfigurationComponent } from './production-plan/admin/create-configuration/create-configuration.component';
import { EditConfigurationComponent } from './production-plan/admin/edit-configuration/edit-configuration.component';
import { ProductionPlanListComponent } from './production-plan/admin/list.component';
import { ProductionPlanInfoDialogueComponent } from './production-plan/production-plan-info-dialogue/production-plan-info-dialogue.component';
import { ProductionPlanNotesDialogComponent } from './production-plan/production-plan-notes-dialog/production-plan-notes-dialog.component';
import { ProductionPlanPathComponent } from './production-plan/production-plan-path/production-plan-path.component';
import { ProductionPlanViewComponent } from './production-plan/production-plan-view/production-plan-view.component';
import { TerminalStatusCellComponent } from './production-plan/terminal-status-cell/terminal-status-cell.component';
import { ConfiguratorComponent } from './sales/configurator/configurator.component';
import { OrderConfigurationComponent } from './sales/orderconfiguration/orderconfiguration.component';
import { PositionsList } from './sales/orderconfiguration/positions/positions-list';
import { OrdersListComponent } from './sales/orderslist/orderslist.component';
import { ConfiguratorPocComponent } from './sales/poc/configurator/configuratorpoc.component';
import { OrderPocComponent } from './sales/poc/order/orderpoc.component';
import { SalesComponent } from './sales/sales.component';
import { CrossAccountOneMonitoringComponent } from './setup/cross-account-one-monitoring/cross-account-one-monitoring.component';
import { FeatureFlagsAdminComponent } from './setup/featureflagsadmin/featureflagsadmin.component';
import { FlagListItemRenderer } from './setup/featureflagsadmin/view/flag-list-item-renderer';
import NameSelectList from './setup/featureflagsadmin/view/name-select-list';
import { SetupComponent } from './setup/setup.component';
import { CreateMappingComponent } from './shared/components/create-mapping/create-mapping.component';
import { EditMappingComponent } from './shared/components/edit-mapping/edit-mapping.component';
import { GenericCalendarComponent } from './shared/components/generic-calendar/generic-calendar.component';
import { GroupedMultiSelectComponent } from './shared/components/grouped-multiselect/grouped-multiselect.component';
import { AggregatePipe } from './shared/services/aggregate.pipe';
import { AccountListItemComponent } from './topbar/account-list-item/account-list-item.component';
import { CustomFilterPipe, DialogLogoutConfirm, DialogNoSelectServiceDialogComponent, TopbarComponent } from './topbar/topbar.component';
import { NgxTranslateModule } from './translate/translate.module';
import { UnknownComponent } from './unknown/unknown.component';
// disabling because we declare web components further down but don't reference them
import '@acies/configurator';

registerLocaleData(localeDa);

// declare @acies/core components, so we get them bundled
Component;
Container;
DefaultSelectListItemRenderer;
Input;
InteractiveContainer;
SelectList;
SelectListItemRenderer;
SelectableContainer;
SVG;
SVGPath;
Text;

// declare @acies/ui components, so we get them bundled
Badge;
Button;
Divider;
Icon;
InputField;
InputPopupSelector;
KeyboardShortcut;
Label;
SpinnerOverlay;
StrokeContainer;
FormInput;
FileDropPicker;
HTMLSelectList;
HTMLSelectListItemRenderer;

// declare core-ui-app components, so we get them bundled
PositionsList;
ComponentCO2List;
ComponentCO2LinkList;
ImportComponentCO2LinkList;
FlagListItemRenderer;
NameSelectList;

@NgModule({
	declarations: [
		AppComponent,
		SignInComponent,
		AdSignInComponent,
		AdSignOutComponent,
		TopbarComponent,
		InsightsComponent,
		ReportsComponent,
		AdministrationComponent,
		LogoutComponent,
		MenuListItemComponent,
		UsersComponent,
		TimezonePickerComponent,
		BudgetsComponent,
		DialogDataDeleteDialogComponent,
		DialogNoSelectServiceDialogComponent,
		DialogUserAccessDialogComponent,
		BreadcrumbComponent,
		DialogUserReportsComponent,
		AccountComponent,
		DialogAccountGroupsComponent,
		DialogDragdropFileComponent,
		DndDirective,
		AdminReportsComponent,
		CustomFilterPipe,
		CoreComponent,
		SlideshowComponent,
		SalesComponent,
		AutoFocusDirective,
		ListItemComponent,
		ReportFilterPipe,
		AccountListItemComponent,
		AccountFilterPipe,
		DialogConfirmForgotPasswordComponent,
		SmallscreensComponent,
		SidebarwidgetComponent,
		UnknownComponent,
		OrderPocComponent,
		ConfiguratorPocComponent,
		GenerictableComponent,
		DialogLogoutConfirm,
		InviteComponent,
		OnlyNumbersDirective,
		OnlyDecimalDirective,
		OnlyPositiveIntegersDirective,
		OnlyRegexPatternDirective,
		NotificationcenterComponent,
		NotificationitemComponent,
		FloatingitemComponent,
		FloatingitemsComponent,
		InneritemComponent,
		FileuploadComponent,
		MasterdataComponent,
		RegistersComponent,
		SingleregisterComponent,
		DialogReportCategoriesComponent,
		ConfirmdialogComponent,
		MesComponent,
		EmployeeComponent,
		CreateUpdateEmployeeDialogComponent,
		WorktasksListComponent,
		MesProductionTerminalComponent,
		WorktaskDialogComponent,
		MesQrComponentComponent,
		SimpleeditdialogComponent,
		PreventDoubleClickDirective,
		HasPermissionDirective,
		DisableWithoutPermissionDirective,
		ArraySortPipe,
		ConfirmdialogComponent,
		DepartmentComponent,
		CreateUpdateDepartmentDialogComponent,
		MesCjsComponent,
		MesCjsTerminalComponent,
		MesCjsTerminalRegisterComponent,
		GenericCalendarComponent,
		CalendarComponent,
		CreateCalendarComponent,
		DeleteCalendarComponent,
		CreateAppointmentComponent,
		UpdateAppointmentComponent,
		CreateHolidaysComponent,
		DocsComponent,
		TemplatesComponent,
		TeamProfilesComponent,
		CreateUpdateTeamProfileDialogComponent,
		MappingsComponent,
		EditMappingComponent,
		CreateMappingComponent,
		TerminalAdministrationComponent,
		EditTerminalComponent,
		CreateTerminalComponent,
		DeleteTerminalComponent,
		TerminalTemplateAdministrationComponent,
		EditTerminalTemplateComponent,
		CreateTerminalTemplateComponent,
		DeleteTerminalTemplateComponent,
		DialogExturlComponent,
		EmployeeCheckinComponent,
		TaskSelectComponent,
		ProductionDataViewComponent,
		ProductionDataViewDetailComponent,
		SetupsComponent,
		CreateUpdateSetupDialogComponent,
		RulesComponent,
		CreateUpdateRuleDialogComponent,
		BasketsComponent,
		CreateUpdateBasketDialogComponent,
		ConfigsComponent,
		CreateUpdateMachineDialogComponent,
		CreateUpdateColorDialogComponent,
		MesBatchComponent,
		CreateBatchComponent,
		EditBatchComponent,
		DeleteBatchComponent,
		BatchStatusComponent,
		GroupingsComponent,
		ConditionalFormatPipe,
		CreateUpdateGroupingDialogComponent,
		PalletsComponent,
		CreateUpdatePalletsDialogComponent,
		PalletisingConfigurationComponent,
		CreateUpdateStackParamDialogComponent,
		ShiftApprovalComponent,
		ShiftChecktimeListComponent,
		ShiftStatusComponent,
		WorktaskSelectComponent,
		IncidentCodeSelectComponent,
		ItemSelectControlComponent,
		CreateShiftNoteComponent,
		MergeShiftsComponent,
		HeaderSubMenuComponent,
		EmployeeNoteComponent,
		EditEmployeeNotesComponent,
		GroupedMultiSelectComponent,
		RackingRacksComponent,
		RackingCreateUpdateRackDialogComponent,
		ProductionPlanViewComponent,
		ProductionPlanListComponent,
		CreateConfigurationComponent,
		EditConfigurationComponent,
		ProductionPlanInfoDialogueComponent,
		ProductionPlanNotesDialogComponent,
		ProductionPlanPathComponent,
		TerminalStatusCellComponent,
		RackingRacksetsComponent,
		RackingCreateUpdateRacksetDialogComponent,
		RackingRulesComponent,
		RackingCreateUpdateRuleDialogComponent,
		CartingCreateUpdateWagonDialogComponent,
		CartingWagonsComponent,
		CartingConfigComponent,
		TerminalStationSelectComponent,
		OnlyZeroAndOneDirective,
		TerminalSelectComponent,
		CalculationsComponent,
		MatricesComponent,
		TerminalMenuComponent,
		ZipCodeComponent,
		CreateUpdateZipCodeDialogComponent,
		TerminalCreateReorderDialogComponent,
		SlidePanelComponent,
		StockReorderComponent,
		TerminalCreateStockReorderDialogComponent,
		UpdateStockReorderComponent,
		DeleteStockReorderComponent,
		CreateScanningPrefixComponent,
		ScanningPrefixComponent,
		UpdateScanningPrefixComponent,
		DeleteScanningPrefixComponent,
		TemplateDeleteConfirmDialogContentComponent,
		ReorderProductionNoteListComponent,
		TerminalCreateProductionNoteComponent,
		MesProductionTerminalTabDialogueComponent,
		ActionMenuElement,
		OrdersListComponent,
		OrderConfigurationComponent,
		ImportErrorPopupComponent,
		TransferErrorPopupComponent,
		AciesDateFormatPipe,
		IncidentCodeComponent,
		CreateIncidentCodeComponent,
		UpdateIncidentCodeComponent,
		DeleteIncidentCodeComponent,
		ProductionNoteComponent,
		CO2Component,
		DynamicPipeComponent,
		AdminComponent,
		IpsettingsComponent,
		DrawingsComponent,
		SyncMonitoringComponent,
		RepairEnvironmentDialogComponent,
		ResetSyncDialogComponent,
		AuditTabComponent,
		AuditReportDialogComponent,
		SourceDriftDialogComponent,
		DriftAuditDialogComponent,
		KeepMarksDialogComponent,
		ReplaySkippedDialogComponent,
		CreateWorkerDialogComponent,
		ScimAdministrationComponent,
		ScimUserDetailDialogComponent,
		ScimGroupDetailDialogComponent,
		ScimTokenDialogComponent,
		CreatePolicyMapDialogComponent,
		PolicyMapDetailDialogComponent,
		PolicyDetailDialogComponent,
		CreatePolicyDialogComponent,
		UpdatePolicyDialogComponent,
		ListPrintConfigurationComponent,
		PrintComponent,
		PrintCollectionJobsComponent,
		PrintJobsComponent,
		PrintTestComponent,
		PrinterAdministrationComponent,
		CreatePrinterComponent,
		EditPrinterComponent,
		DeletePrinterComponent,
		FeatureFlagsComponent,
		SetupComponent,
		FeatureFlagsAdminComponent,
		CrossAccountOneMonitoringComponent,
		CreateUpdateLayerParamDialogComponent,
		ConfiguratorComponent,
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		BrowserModule,
		AppRoutingModule,
		ReactiveFormsModule,
		MaterialModule,
		BrowserAnimationsModule,
		FormsModule,
		OverlayModule,
		PowerBIEmbedModule,
		MatChipsModule,
		// NgMaterialMultilevelMenuModule,
		FileSaverModule,
		Breadcrumb2Module,
		CountdownModule,
		NgxTranslateModule,
		NgClickOutsideDirective,
		A11yModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatTooltip,
		MatExpansionModule,
		MatProgressBarModule,
		QRCodeComponent,
		MatTooltipModule,
		ServiceWorkerModule.register('cjs-ngsw-worker.js', {
			// Was previously "ngsw-worker.js" for the native Angular SW
			// "Enabled" was originally "!isDevMode()" after installation of angular/pwa, but that throws a build error:
			// https://stackoverflow.com/questions/47714132/cannot-enable-prod-mode-after-platform-setup-angular-5-production-build
			enabled: environment.production,
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000',
		}),
		AggregatePipe,
	],
	providers: [
		// SessionStorageService, // Moved to {providedIn: 'root'} in the service --https://medium.com/@pratap-aditya/angular-providedin-vs-providers-arrays-17b475f03cbb
		// LocalStorageService,   // Moved to {providedIn: 'root'} in the service
		{ provide: 'WINDOW', useValue: window },
		{ provide: MAT_DATE_LOCALE, useValue: 'da-DK' },
		{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
		{ provide: DateAdapter, useClass: CustomDateAdapter },
		{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlCustom },
		UserToNamePipe,
		SyncStatusTranslatePipe,
		provideHttpClient(withXhr()),
		Apollo,
		{
			provide: APOLLO_OPTIONS,
			useFactory: (graphqlProvider: GraphQLProvider, httpLink: HttpLink) => graphqlProvider.apolloOptionsFactory(httpLink),
			deps: [GraphQLProvider, HttpLink],
		},
		// Add GraphQL providers
		UpdateBatchMutation,
		UpdateBatchSubscription,
		DeleteBatchSubscription,
		CreateProductionNoteSubscription,
		DeleteProductionNoteSubscription,
		UpdateProductionNoteSubscription,
		UpdateTerminalStatusSubscription,
		CreateBatchSubscription,
		CompleteItemOperationSubscription,
		ReorderItemOperationSubscription,
		GetItemOperationsByTerminalAndBatchQuery,
		CreateActiveElementSubscription,
		provideHttpClient(withXhr(), withInterceptorsFromDi(), withJsonpSupport()),
	],
})
export class AppModule {}
